import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  showFailureNotification,
  showSuccessNotification,
} from 'gcs-agent-web/src/slices/notifications/ShowNotificationThunk';
import { convertHouseUpdateValues } from 'gcs-common/helper/houseAdministrationHelper';
import { fetchSelectedHouse } from 'gcs-common/slices/administration/houses/housesThunks';
import { useDispatch } from 'react-redux';
import type { Parameters, RequestBody } from './../../../../../types/typeHelper';
import { useApiClient } from '../../client';
import { CurrentUserQueryKeys } from '../current-user/current-user-api';

export function useUpdateHouseMutation() {
  const queryClient = useQueryClient();
  const client = useApiClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async ({
      body,
      path,
    }: {
      body: RequestBody<'/admin/houses/{house_id}', 'put'>;
      path: Parameters<'/admin/houses/{house_id}', 'put'>['path'];
    }) => {
      return client.PUT('/admin/houses/{house_id}', {
        params: {
          path,
        },
        body: convertHouseUpdateValues(body),
      });
    },
    onError: (error: Error) => {
      dispatch(showFailureNotification(error.message));
    },
    onSuccess: (_data, variables) => {
      dispatch(showSuccessNotification('Erfolgreich geändert'));
      // @ts-expect-error Redux dispatch is not typed for async thunks in this file.
      dispatch(fetchSelectedHouse({ houseId: variables.path.house_id }));
    },
    onSettled: async () => {
      queryClient.invalidateQueries({ queryKey: [CurrentUserQueryKeys.GET_CURRENT_USER] });
    },
  });
}
